export const applicationsKeys = {
    APPLICATIONS_CREATE: 'application/create',
    APPLICATIONS_UPDATE: 'application/update',
    APPLICATIONS_DELETE: 'application/delete',
    APPLICATIONS_READ: 'application/read',

    APPLICATIONS_STUDENTS_READ: 'students/read',

};